import { VStack } from '@looko-design-system';
import { Typography } from '@mui/material';
import { convertNewlineToJSX } from '@toss/react';

import ContentLayout from '../layout/contentLayout';

/**
 * 앱 치명적 오류 페이지 Screen 컴포넌트
 *
 * 애플리케이션에서 복구 불가능한 심각한 오류가 발생했을 때 표시되는 화면입니다.
 * - Sentry를 통한 자동 에러 리포팅
 * - 사용자에게 오류 상황 안내
 * - 새로고침을 통한 앱 재시작 유도
 * - 지속적인 문제 발생 시 고객 지원 안내
 *
 * @description 분석 화면명: 앱_치명적오류
 */
export default function CriticalErrorPage() {
  return (
    <ContentLayout>
      <VStack
        flex={1}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        sx={{
          width: '100%',
          height: '100vh',
        }}
      >
        <img width={400} src="/assets/logo/aclosetFullLogoBlack.png" alt="심각한 오류 발생" />

        <Typography variant="h4" mt={3} mb={1} color={'error'} textAlign={'center'}>
          {convertNewlineToJSX(
            '죄송합니다. 복구 불가능한 오류가 발생했습니다.\n처음부터 다시 시작해주세요.\n(오류는 자동으로 보고되었습니다.)',
          )}
        </Typography>

        <Typography variant="h5">문제가 지속되면 연락 부탁드립니다.</Typography>
      </VStack>
    </ContentLayout>
  );
}
